<template>
  <div class="btn-set mb-0 mt-3">
    <div class="lower-z-index mt-3" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="200">
      <div class="col-md-12 col-sm-12 mb-4">
        <div class="text-center">
          <b-button variant="secondary" @click="$emit('back')">{{ $t('back') }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
}
</script>
